import type { Index } from "diagnostics-lib/iterable";
import type { ParsingRule } from "../../../types";

export const columnsMandatory = [
  ["invalidatedQuantity"],
  ["source"],
  ["minimumValue"],
  ["maximumValue"],
  ["maximumStd"],
];

export const columns = [...columnsMandatory];

/**
 * @description Check if file contains all required columns.
 */
export const hasInvalidColumns: ParsingRule = (header: string[]) => {
  const data = columnsMandatory;
  return data.every(columnsM => columnsM.some(col => header?.includes(col))) ? false : true;
};

/**
 * @description Check if file contains all required columns.
 */
export const hasInvalidFileEmpty: ParsingRule = (content: string[]) => content.length === 0;

/**
 * @description Check if the name column, on a given line, contain unexpected value.
 */
export const hasUnexpectedQuantityName: ParsingRule = (
  quantityName: string,
  expectedNameValues: string[],
) => (quantityName && !expectedNameValues.includes(quantityName) ? true : false);

export const hasMinSuperiorToMax = (minimumValue: string, maximumValue: string) =>
  minimumValue &&
  maximumValue &&
  !window.isNaN(parseFloat(minimumValue)) &&
  !window.isNaN(parseFloat(maximumValue)) &&
  parseFloat(minimumValue) >= parseFloat(maximumValue);

export const hasNegativeMaxStd = (maximumStd: string) =>
  !window.isNaN(parseFloat(maximumStd)) && parseFloat(maximumStd) < 0;

export const hasNotNumberValue = (value: string) =>
  value ? window.isNaN(parseFloat(value)) : false;

export const isValuesNotNull = (
  maximumStdString: string,
  maximumValueString: string,
  minimumValueString: string,
) => !maximumStdString && !maximumValueString && !minimumValueString;

export const hasInvalidQuantityNameEmpty = (quantityName: string) =>
  Boolean(quantityName) === false;

export const hasInvalidSourceQuantity = (
  maximumStd: string,
  sourceName: string,
  indexQuantityByName: Index<
    {
      name: string;
      formula: string | null;
    },
    string
  >,
) => {
  const quantity = indexQuantityByName.get(sourceName);
  if (!quantity) return false;
  return maximumStd && quantity.formula !== null;
};
